export const devices = {
  // We have to specify 801 so that the media query applies styles to 800px and below
  desktop: '(min-width: 801px)',
};

export default devices;
